import React from 'react';
import { Spinner } from 'components/elements/Spinner';
import Header from 'components/widgets/SearchFilterWizard/steps/components/Header';
import SectionWrapper from 'components/widgets/SearchFilterWizard/steps/components/SectionWrapper';

const SavingStep = () => {
  return (
    <SectionWrapper
      sx={{
        gap: 'padding_24',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
      }}
    >
      <Spinner size="lg" />
      <Header
        title="Saving your filters..."
        description="This won't take long, we're building your feed."
      />
    </SectionWrapper>
  );
};

export default SavingStep;
